<template>
    <li class="nav-item nav-item-dropdown-lg dropdown">
        <a href="#" class="navbar-nav-link navbar-nav-link-toggler" data-toggle="dropdown">
            <i class="icon-bell3"></i>
            <span v-show="unreadNotifications.length > 0" class="badge badge-danger badge-pill ml-auto ml-lg-0">{{ unreadNotifications.length }}</span>
        </a>

        <div class="dropdown-menu dropdown-menu-right dropdown-content wmin-lg-350">
            <div class="dropdown-content-header py-2">
                <h4 class="font-weight-semibold mb-0">Aviseringar</h4>
            </div>

            <div class="dropdown-content-body dropdown-scrollable p-0">
                <ul v-if="unreadNotifications.length > 0" class="media-list">
                    <li v-for="not in unreadNotifications" :key="'n-' + not.id" class="media border-top m-0 py-2 px-3">
                        <div class="media-body">
                            <div class="d-flex flex-row">
                                <div class="media-title flex-grow-1">
                                    <span class="font-weight-semibold">{{ not.message }}</span>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        class="btn btn-secondary-100 text-secondary btn-icon rounded-pill btn-sm"
                                        style="width: 26px; height: 26px;"
                                        @click="markNotificationAsRead(not)"
                                    ><i class="icon-cross3"></i></button>
                                </div>
                            </div>
                            <span class="text-muted font-size-sm">{{ formatDateTime(not.created_at) }}</span>
                        </div>
                    </li>
                </ul>
                <div v-else class="border-top m-0 py-2 px-3"><i>Inga olästa aviseringar...</i></div>
            </div>

<!--            <div class="dropdown-content-footer justify-content-center p-0">-->
<!--                <a href="#" class="btn btn-light btn-block border-0 rounded-top-0" data-popup="tooltip" title="Load more"><i class="icon-menu7"></i></a>-->
<!--            </div>-->
        </div>
    </li>
</template>

<script>
import { formatDateTime } from '@services/Helpers';
import { useNotificationsStore } from '@services/pinia/NotificationsStore';
import { mapState, mapActions } from 'pinia';

export default {
    name: 'LimitlessPageTopNotificationsDropdown',
    methods: {
        formatDateTime,
        ...mapActions(useNotificationsStore, ['markNotificationAsRead']),
    },
    computed: {
        ...mapState(useNotificationsStore, ['unreadNotifications']),
    },
    created() {
        useNotificationsStore().getNotifications();
    },
};
</script>

<style>
.navbar-custom-bg .navbar-nav-link:hover, .navbar-custom-bg .navbar-nav-link:focus {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.15);
}
</style>
